import { render, staticRenderFns } from "./BasePropTabOptions.vue?vue&type=template&id=772a9052&scoped=true&"
import script from "./BasePropTabOptions.vue?vue&type=script&lang=js&"
export * from "./BasePropTabOptions.vue?vue&type=script&lang=js&"
import style0 from "./BasePropTabOptions.vue?vue&type=style&index=0&id=772a9052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772a9052",
  null
  
)

export default component.exports